// extracted by mini-css-extract-plugin
export default {"cta":"tH-z","disabled":"uH-z"};